import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span
                className="text-2xl font-bold tracking-tight"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                <span className="text-accent-500">韩漫</span>
                <span className="text-background-50">世界</span>
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed">
              韩漫世界 —— 你的韩漫阅读天堂。提供海量无删减韩国漫画，支持下拉式流畅阅读，每日更新，畅享极致漫画体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  奇幻冒险
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  热血动作
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              热门推荐
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/comic/solo-leveling" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  我独自升级
                </Link>
              </li>
              <li>
                <Link to="/comic/duke-contract-fiancee" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  公爵的契约未婚妻
                </Link>
              </li>
              <li>
                <Link to="/comic/omniscient-reader" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  全知读者视角
                </Link>
              </li>
              <li>
                <Link to="/comic/sword-master-second-son" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  剑术名家的二公子
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-mail-line"></i>
                <span>contact@hanmanshijie.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-customer-service-line"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-map-pin-line"></i>
                <span>韩国首尔特别市江南区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} 韩漫世界 HanManShiJie. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/50 hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-50/50 hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-background-50/50 hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}